import { InputNumeric } from './InputNumeric'

export const InputCurrency = (props) => {
  return (
    <InputNumeric
      style={{ width: '200px' }}
      formatter={(value) => (value === '' ? '0' : `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','))}
      parser={(value) => value.replace(/(,*)/g, '')}
      {...props}
    />
  )
}
